import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import Button from './ui/Button';

/**
 * A delete that asks first, in place - the same two steps as deactivating a
 * user. When the delete is known to be refused (`disabledReason`), the button
 * stays in view but disabled, with the reason under it, so nobody has to try
 * to find out. The server still has the last word, and its message is shown
 * here when it refuses anyway.
 */
function AdminDeleteControl({ label, confirmText, disabledReason, onDelete }) {
  const { t } = useTranslation();

  const [isConfirming, setIsConfirming] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  const [error, setError] = useState('');

  async function handleDelete() {
    try {
      setIsDeleting(true);
      setError('');

      await onDelete();
    } catch (deleteError) {
      console.error('Delete failed:', deleteError);

      setError(deleteError?.message || t('adminPanel.errorGeneric'));
      setIsConfirming(false);
    } finally {
      setIsDeleting(false);
    }
  }

  return (
    <div className="admin-delete-control">
      {error && (
        <div className="login-message login-message-error" role="alert">
          <i className="fa-solid fa-circle-exclamation" />
          <span>{error}</span>
        </div>
      )}

      {isConfirming ? (
        <div className="admin-confirm-row">
          <span>{confirmText}</span>

          <Button
            variant="secondary"
            disabled={isDeleting}
            onClick={() => setIsConfirming(false)}
          >
            {t('adminPanel.cancel')}
          </Button>

          <Button
            variant="secondary"
            className="admin-danger-button"
            disabled={isDeleting}
            onClick={handleDelete}
          >
            {isDeleting
              ? t('adminPanel.deleting')
              : t('adminPanel.deleteConfirmButton')}
          </Button>
        </div>
      ) : (
        <Button
          variant="secondary"
          className="admin-danger-button"
          disabled={Boolean(disabledReason)}
          title={disabledReason || undefined}
          onClick={() => {
            setError('');
            setIsConfirming(true);
          }}
        >
          <i className="fa-regular fa-trash-can" />
          {label}
        </Button>
      )}

      {disabledReason && !isConfirming && (
        <p className="admin-disabled-reason">{disabledReason}</p>
      )}
    </div>
  );
}

export default AdminDeleteControl;
